import axios from "axios";
import { Toast } from "vant";
import { catchError, getStorage } from "./common.js"

/**
 * 公共请求
 * @param {*} url
 * @param {*} options
 */
function request(
  url,
  options = {
    method: "GET",
    headers: {
    },
    data: {},
    params: {},
  }
) {
  let res = getStorage('liveuser')
  if(res) {
    options.headers = {
      'X-Access-Token': res.token,
    };
  }

  if(url.indexOf('chat/record/list')<0 && url.indexOf('product/trade/status')<0 && url.indexOf('onlineCnt')<0 && url.indexOf('chat/record/lectureList')<0&& url.indexOf('chat/live/lectureList')<0 && url.indexOf('canWatchLive')<0 && url.indexOf('account/errorReport')<0 && url.indexOf('course/live/share')<0&&url.indexOf('sharePic')<0 && url.indexOf('teacherReady')<0 && url.indexOf('canViewReplay')<0 && url.indexOf('account/userInfo')<0&&url.indexOf('course/live/showProductTips')<0){
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    });   
  }
  
  const defaultOptions = {
    // credentials: "include",
    withCredentials: true,
  };
  const newOptions = {
    ...defaultOptions,
    ...options,
    url: url,
    timeout: 5000,
  };
  
  if (
    newOptions.method === "POST" ||
    newOptions.method === "PUT" ||
    newOptions.method === "DELETE"
  ) {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        ...newOptions.headers,
      };
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: "application/json",
        ...newOptions.headers,
      };
    }
  }
  // 添加拦截器
  const interceptor = axios.interceptors.response.use(
    (response) => {
      const { data: res } = response;
      const { code, message, result, status } = res;
      if (code === 1) {
        Toast.clear()
        return result;
      } else if (status === 401 || status === 10002) {
        Toast.fail(message);
        return Promise.reject(message);
      } else {
        if(url.indexOf('product/coupon/list/v2')<0){
          Toast.fail(message);
        }
        return Promise.reject(message);
      }
    },
    async (error) => {
      try {
        catchError(error)
      } catch (error) {
        // clearAll()
      }
      // return Promise.reject(error);
    }
  );
  const instans = axios(newOptions);
  axios.interceptors.response.eject(interceptor); // 取消拦截器
  return instans;
}

export default request;